import webContextProvider from "../../../../providers/webContextProvider";
import clientConfigurationProvider from "../../../../providers/clientConfigurationProvider";

const isDiscountLabelEnabled = () => {
  const { discountLabelEnabledStores } = clientConfigurationProvider();
  const { storeId } = webContextProvider();

  return discountLabelEnabledStores.includes(storeId);
};

export default isDiscountLabelEnabled;
